import { render } from "./IphoneSwitch.vue?vue&type=template&id=416b5dd8&scoped=true"
import script from "./IphoneSwitch.vue?vue&type=script&lang=js"
export * from "./IphoneSwitch.vue?vue&type=script&lang=js"

import "./IphoneSwitch.vue?vue&type=style&index=0&id=416b5dd8&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416b5dd8"]])

export default __exports__